import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/redchilunbi.png'
import _imports_1 from '@/assets/image/wx.png'


const _withScopeId = n => (_pushScopeId("data-v-d6e2bf0a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "withdraw" }
const _hoisted_2 = { class: "balance" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "可提现余额", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "(1齿轮币=1人民币)", -1))
const _hoisted_8 = { class: "balance1" }
const _hoisted_9 = { class: "one" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "yue" }, "提现余额", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "two" }, "单笔提现金额不得超过¥2000元", -1))
const _hoisted_13 = { class: "type" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "提现方式", -1))
const _hoisted_15 = { class: "wx" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "微信", -1))
const _hoisted_18 = { class: "my-2 flex items-center text-sm" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("template", null, null, -1))
const _hoisted_20 = { class: "viprecord" }
const _hoisted_21 = { class: "title" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "提现规则说明", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "record" }, [
  /*#__PURE__*/_createElementVNode("div", null, " （1） 提现时间：由于财务审核、遇节假日、不可抗力等原因，部分时间段将无法支持提现操作，如出现延迟，我们将于1-3个工作日反馈。 "),
  /*#__PURE__*/_createElementVNode("div", null, " （2） 提现额度：除另有约定外，单笔提现不少于100元，不超过2000元。 "),
  /*#__PURE__*/_createElementVNode("div", null, " （3） 到账时间：提交提现申请后，由于财务审核及计算个人所得税等原因，提现款将于次月月末之前转入您的账户。 具体时间以第三方支付渠道（如微信）为准。 "),
  /*#__PURE__*/_createElementVNode("div", null, " （4） 税费说明：您在设纪元上传作品属于稿酬所得，设纪元将根据现行《中华人民共和国个人所得税法》相关法规规定，以提现款项的支付方（如：辰星（天津）自动化设备有限公司）为扣缴义务人，为您申报并预扣预缴/代扣代缴个人所得税，具体时间节点为提现当月 。税费将根据您一个自然月的提现总金额计算。 "),
  /*#__PURE__*/_createElementVNode("div", null, " （5） 实名认证：每个实名认证信息只可绑定一个设纪元账号，设纪元将根据您的实名认证信息申报相关税费。 "),
  /*#__PURE__*/_createElementVNode("div", null, " （6） 提现条件：您应满足提现的前置条件，并根据提现页面提示的流程、规范进行提现操作。如因您自身原因导致提现失败（包括但不限于未按提现要求操作、未完成实名认证、未绑定收款账号、实名认证信息有误或已绑定其他设纪元账号、实名认证信息/预留的收款账号信息/第三方支付渠道账号不一致、已与第三方支付渠道解绑账号等），设纪元无需承担任何责任。 "),
  /*#__PURE__*/_createElementVNode("div", null, " （7） 承诺与保证：您理解并同意，如您存在违反法律法规、《设纪元网站使用规则》及其他设纪元协议规范、活动规则的行为，或通过任何不正当、违反诚实信用原则的方式（包括但不限于提供虚假信息、反复注销注册、一人多号或利用机器人软件/蜘蛛软件等技术手段）进行提现，设纪元有权单方面中止/终止向您提供全部或部分服务（包括但不限于获取齿轮币收益的资格），并有权拒绝您的提现申请或要求您返还已提现收益。 ")
], -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("template", null, null, -1))
const _hoisted_25 = { class: "viprecord" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("p", null, "提现通知")
], -1))
const _hoisted_27 = { class: "record" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 请登录设纪元微信小程序提现，小程序 正在建设中，请您在小程序上线后进行 提现操作。 ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_Title = _resolveComponent("Title")!
  const _component_InvoiceDialog = _resolveComponent("InvoiceDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("i", {
          class: "iconfont",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setDialogVisible()))
        }, ""),
        _hoisted_4,
        (_ctx.getInformation.data.sgear != null)
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.getInformation.data.sgear), 1))
          : _createCommentVNode("", true),
        (_ctx.getInformation.data.sgear == null)
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, "0"))
          : _createCommentVNode("", true),
        _hoisted_7
      ]),
      _createVNode(_component_el_form, {
        ref: "ruleFormRef",
        model: _ctx.moneyinput,
        rules: _ctx.rules
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _hoisted_11,
              _createVNode(_component_el_form_item, { prop: "money" }),
              _createVNode(_component_el_input, {
                modelValue: _ctx.moneyinput.money,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.moneyinput.money) = $event)),
                onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.checkAges(_ctx.moneyinput.money)))
              }, null, 8, ["modelValue"]),
              _createElementVNode("span", null, "¥" + _toDisplayString(_ctx.moneyinput.money) + "元", 1)
            ])
          ]),
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _hoisted_17,
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_el_radio_group, {
                  modelValue: _ctx.radio2,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.radio2) = $event)),
                  class: "ml-4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ])
          ]),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                class: "routine submit",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.submitForm(_ctx.ruleFormRef)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("提现")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"]),
      _createElementVNode("div", {
        class: "check",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.torecord('third')))
      }, "查看提现记录")
    ]),
    _createVNode(_component_InvoiceDialog, {
      ref: "sonRef",
      dialogwidth: "580px"
    }, {
      header: _withCtx(() => [
        _createVNode(_component_Title, {
          headerHeight: 40,
          headerBC: "#F2F5FA"
        }, {
          default: _withCtx(() => [
            _hoisted_19
          ]),
          _: 1
        })
      ]),
      default: _withCtx(({}) => [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("i", {
              class: "iconfont",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.mclose()))
            }, "")
          ]),
          _hoisted_23
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_InvoiceDialog, {
      ref: "sonRefs",
      dialogwidth: "580px",
      class: "tongzhi"
    }, {
      header: _withCtx(() => [
        _createVNode(_component_Title, {
          headerHeight: 40,
          headerBC: "#F2F5FA"
        }, {
          default: _withCtx(() => [
            _hoisted_24
          ]),
          _: 1
        })
      ]),
      default: _withCtx(({}) => [
        _createElementVNode("div", _hoisted_25, [
          _hoisted_26,
          _createElementVNode("div", _hoisted_27, [
            _hoisted_28,
            _createElementVNode("button", {
              class: "routine",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.mcloses()))
            }, "我知道了")
          ])
        ])
      ]),
      _: 1
    }, 512)
  ], 64))
}